module.exports = __webpack_public_path__ + "static/media/05.a2f25391.png";